export default "__VITE_ASSET__C2kxSzY7__"